export default __webpack_public_path__ + "images/parent-signup/olzoo-7ed0246906e8b7c7de76c01c4a72fa3c.svg";